import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=accab4b0&scoped=true"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"
import style0 from "./Talk.vue?vue&type=style&index=0&id=accab4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accab4b0",
  null
  
)

export default component.exports